@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.DeleteButton {
  display: inline-flex;
  padding: 6px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: none;
  color: $color-primary-red;

  // Tooltip uses span to wrap children
  > span {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }

  &:active {
    outline: none;
    background: $theme-color-button-delete-active-background;
  }

  &.condense {
    padding: 4px;
  }

  &.withText {
    @extend %form-control-font;

    padding: 0;
    border: 1px solid $theme-color-secondary-button-border;
    background: $theme-color-background;

    > span {
      padding: 6px 16px;
      column-gap: 8px;
    }

    &.condense {
      > span {
        padding: 3px 8px;
        column-gap: 6px;
      }
    }

    &:hover {
      background: $theme-color-secondary-button-hover;
    }

    &:active {
      background: $theme-color-secondary-button-active;
    }
  }

  &:disabled {
    cursor: default;
    color: $color-grey-A;
    opacity: 0.3;

    &:hover {
      background: none;
    }

    &:active {
      background: none;
    }

    &.withText {
      border: 1px solid $theme-color-secondary-button-border;
      opacity: 1;
    }
  }

  // needed to override default icon greyA
  &.condenseWithoutText {
    &:active:enabled,
    &:hover:enabled {
      > span {
        > span {
          > svg {
            color: $theme-color-button-delete-danger-color;
          }
        }
      }
    }
  }
}
